import React from 'react';
import PropTypes from 'prop-types';

import ExpanderHelpers from '../helpers/expander-helpers';

class Expander extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			expanded: false,
		};

		this.handleClick = this.handleClick.bind(this);
		this.getExpanderClass = this.getExpanderClass.bind(this);
	}
	handleClick() {
		this.setState(prevState => ({
			expanded: !prevState.expanded
		}));
	}
	getExpanderClass() {
		let clsName = "frame expander ";
		
		if (this.props.className) { 
			clsName += this.props.className + " ";
		}
		
		clsName += ExpanderHelpers.displayExpansion(this.state.expanded);

		return clsName;
	}
	render() {
		let expanderIcon = "";
		if (!this.state.expanded) {
			expanderIcon = "\u25BC";
		} else {
			expanderIcon = `\u25B2`;
		}
		return (
			<div className={this.getExpanderClass()}>
				<div className="row title" onClick={this.handleClick}>
					<div className="columns eleven"><h6>{this.props.title}</h6></div>
					<div className="column one icon"><h6>{expanderIcon}</h6></div>
				</div>
				<div className="row">
					<div className="content">
						{this.props.children}
					</div>
				</div>
			</div >
		);
	}
}

Expander.propTypes = {
	title: PropTypes.string,
	className: PropTypes.string,
};

export default Expander;


// WEBPACK FOOTER //
// ./src/components/Expander.js